// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobs-results[data-v-65b95f59]{display:grid;grid-template-columns:repeat(3, 1fr);gap:1.5rem}@media(max-width: 1080px){.jobs-results[data-v-65b95f59]{grid-template-columns:repeat(2, 1fr)}}@media(max-width: 560px){.jobs-results[data-v-65b95f59]{grid-template-columns:1fr}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
